module.exports = __webpack_public_path__ + "img/cotLogo.c005e62e.jpeg";